import ReactToPrint from 'react-to-print';
import { Link } from 'react-router-dom';
import { memo, useState, useContext } from 'react';
import { getRequest } from '../../utils/axiosRequests';
import TemplateSearchArea from './partials/templateSearchArea';
import AddAttachmentModal from './modals/addAttachment';
import PrescriptionNoteModal from './modals/prescrptionNote';
import TopLeftMenu from './partials/topLeftMenu';
import { useSelector } from 'react-redux';
import { PrescriptionTopContext } from '../../contexts/PrescriptionTopContext';
import { usePostRequest } from '../../hooks/usePostRequest';

const PrescriptionTop = ({
  printRef,
  prescriptionId,
  title,
  setTitle,
  files,
  setFiles,
  handlePrintStatus,
  note,
  setNote,
  setOpenVideoModal,
  onlineUserExist,
}) => {
  const { patientInfo } = useContext(PrescriptionTopContext);
  const userInfo = useSelector((state) => state.authReducer.data);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [templatesInSearch, setTemplatesInSearch] = useState([]);
  const [isNoteModal, setIsNoteModal] = useState(false);
  const [isAttachmentModal, setIsAttachmentModal] = useState(false);

  const handleOnInputChange = (searchKey) => {
    if (!searchKey || searchKey.length < 3) return;
    setIsLoading(true);
    const url = `prescriptions/templates-groups?name=${searchKey.toString()}`;
    setSearchQuery(searchKey.toString());

    getRequest(url)
      .then((data) => {
        let customizedResults = [];
        if (data?.prescriptionTemplates?.length > 0) {
          const templateData = data?.prescriptionTemplates?.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
              type: 'Prescription Template',
            };
          });
          customizedResults = [...customizedResults, ...templateData];
        }
        if (data?.chiefComplainGroups?.length > 0) {
          const complainData = data?.chiefComplainGroups?.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
              type: 'Chief complain group',
            };
          });
          customizedResults = [...customizedResults, ...complainData];
        }
        if (data?.adviceGroups?.length > 0) {
          const adviceData = data?.adviceGroups?.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
              type: 'Advice group',
            };
          });
          customizedResults = [...customizedResults, ...adviceData];
        }
        if (data?.diagnoisGroups?.length > 0) {
          const diagnosisData = data?.diagnoisGroups?.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
              type: 'Diagnosis group',
            };
          });
          customizedResults = [...customizedResults, ...diagnosisData];
        }
        if (data?.rxGroups?.length > 0) {
          const diagnosisData = data?.rxGroups?.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
              type: 'Medicine group',
            };
          });
          customizedResults = [...customizedResults, ...diagnosisData];
        }
        if (data?.investigationGroups?.length > 0) {
          const investigationData = data?.investigationGroups?.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
              type: 'Investigation group',
            };
          });
          customizedResults = [...customizedResults, ...investigationData];
        }
        if (data?.medicalGroups?.length > 0) {
          const medicalData = data?.medicalGroups?.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
              type: 'Medical History group',
            };
          });
          customizedResults = [...customizedResults, ...medicalData];
        }
        if (data?.patientList?.length > 0) {
          const patientData = data?.patientList?.map((item) => {
            let patintExtraInfoToShow = '';
            const idForDoctor = item.patientIdForDoctor?.find(
              (idItem) => idItem?.doctorId === userInfo.id,
            );

            const patientId = idForDoctor ? idForDoctor.patientId : '';

            if (patientId) {
              patintExtraInfoToShow += patientId;
            }

            if (item?.phoneNumber) {
              patintExtraInfoToShow += ', ' + item.phoneNumber;
            }

            return {
              ...item,
              label: item.name,
              value: item.name + ' ,' + patintExtraInfoToShow,
              type: 'Patient',
              doctorId: userInfo.id,
              patientId,
            };
          });
          customizedResults = [...customizedResults, ...patientData];
        }
        setTemplatesInSearch([...customizedResults]);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const { isPushNotificationSendLoading, mutate: sendPushNotification } =
    usePostRequest(
      'auth-patient/send-push-notification',
      {
        patientId: patientInfo?.id,
        roomName: userInfo.id + '_' + patientInfo?.id,
      },
      (data) => {
        console.log(data);
      },
      (e) => {
        console.log(e);
      },
    );

  const callHandler = () => {
    sendPushNotification();
    setOpenVideoModal(true);
  };

  return (
    <div className="row mb-2">
      <div className="col-md-12 sticky-header shadow header-sticky-second">
        <TopLeftMenu />
        <div className="right-side-pres">
          {userInfo?.doctorDetails?.enabledOnline &&
            userInfo?.doctorDetails?.isVideoCall && (
              <>
                <div className="">
                  {onlineUserExist && <div className="patient_online"></div>}
                  {!onlineUserExist && <div className="patient_offline"></div>}
                </div>
                <div className="cursor-pointer small_menu_item">
                  <Link
                    to={''}
                    title="Patient Call"
                    // className={appointmentStatus === 'completed' ? '' : 'disabled-link'}
                    style={{
                      // marginRight: '20px',
                      color: 'white',
                      textDecoration: 'none',
                    }}
                    onClick={() => callHandler()}
                  >
                    {/* <span className="take-note">Patient Call</span> */}
                    {/* <span>
                      <i className="fa fa-phone"></i>
                    </span> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="bi bi-headset"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5" />
                    </svg>
                  </Link>
                </div>
              </>
            )}

          <div title="Attatchments" className="cursor-pointer small_menu_item">
            {prescriptionId ? (
              <Link
                to={'/attachments'}
                state={{ patientId: patientInfo?.id, prescriptionId }}
              >
                {/* <span className="take-note">Attachments</span> */}
                {/* <span>
                  <i className="fa fa-paperclip"></i>
                </span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="white"
                  class="bi bi-paperclip"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                </svg>
              </Link>
            ) : (
              <div onClick={() => setIsAttachmentModal(true)}>
                {/* <span className="take-note">Attachments</span> */}
                {/* <span>
                  <i className="fa fa-paperclip"></i>
                </span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-paperclip"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                </svg>
              </div>
            )}
          </div>
          <div
            title="Take Note"
            className="cursor-pointer small_menu_item"
            onClick={() => setIsNoteModal(true)}
          >
            {/* <span className="take-note">Take Note</span> */}
            {/* <span>
              <i className="fas fa-edit"></i>
            </span> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-file-earmark-medical"
              viewBox="0 0 16 16"
            >
              <path d="M7.5 5.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L6 7l-.549.317a.5.5 0 1 0 .5.866l.549-.317V8.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L8 7l.549-.317a.5.5 0 1 0-.5-.866l-.549.317zm-2 4.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z" />
              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
            </svg>
          </div>
          <div title="Print Preview" className="cursor-pointer small_menu_item">
            <ReactToPrint
              trigger={() => (
                // <span>
                //   {/* <span className="take-note">Print Preview</span> */}
                //   <i className="fa fa-print" aria-hidden="true"></i>
                // </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-printer"
                  viewBox="0 0 16 16"
                >
                  <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                  <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                </svg>
              )}
              onBeforePrint={() => handlePrintStatus(true)}
              onAfterPrint={() => handlePrintStatus(false)}
              content={() => printRef.current}
            />
          </div>
          <div className="template-search">
            <TemplateSearchArea
              handleOnInputChange={handleOnInputChange}
              searchQuery={searchQuery}
              options={templatesInSearch}
              placeholder={'template'}
            />
          </div>
        </div>

        <PrescriptionNoteModal
          note={note}
          setNote={setNote}
          isNoteModal={isNoteModal}
          setIsNoteModal={setIsNoteModal}
        />
        <AddAttachmentModal
          isAttachmentModal={isAttachmentModal}
          setIsAttachmentModal={setIsAttachmentModal}
          title={title}
          setTitle={setTitle}
          files={files}
          setFiles={setFiles}
        />
      </div>
    </div>
  );
};

export default memo(PrescriptionTop);
